export const GET_APPLICATION_BY_APPLICANT_ID = gql`
  query ApplicationByApplicantId($applicantId: String!) {
    applicationByApplicantId(applicantId: $applicantId) {
      applicationId
      status
      firstName
      middleName
      lastName
      email
      phone
      dob
      ssn
      issuingCountry
      yearsOfExperience
      availableForWork
      createdAt
      updatedAt
      drivingExperiences {
        drivingExperienceId
        equipmentClass
        equipmentType
        startDate
        endDate
        approxMilesDriven
      }
      trackingLink {
        trackingLinkId
        linkType
        linkName
        link
      }
      applicant {
        applicantId
        yearsOfExperience
        applicationDate
        hiringStage
        applicantStage
        jobListing {
          jobListingId
          title
          type
          minEmploymentHistoryYears
        }
      }
      license {
        licenseId
        licenseNumber
        licenseClass
        state
        country
        expirationDate
        medicalExamExpirationDate
        endorsements
        createdAt
        updatedAt
        isLicenseSuspended
        licenseSuspendedReason
      }
      twicCard {
        twicCardId
        createdAt
        updatedAt
        cardNumber
        expirationDate
      }
      equipment {
        equipmentId
        createdAt
        updatedAt
        type
        year
        make
        model
        color
        vin
        weight
        mileage
        fifthWheelHeightInches
      }
      previousLicenses {
        licenseId
        licenseNumber
        licenseClass
        state
        country
        expirationDate
        medicalExamExpirationDate
        endorsements
        createdAt
        updatedAt
        isLicenseSuspended
        licenseSuspendedReason
      }
      addresses {
        addressId
        street
        city
        state
        country
        zipCode
        startDate
        endDate
      }
      accidents {
        accidentId
        createdAt
        updatedAt
        accidentDate
        city
        state
        country
        description
        isPreventable
        isCommercialMotorVehicleInvolved
        involvedFatalities
        involvedInjuries
      }
      employmentExperiences {
        isUnemployment
        unemploymentReason
        employmentExperienceId
        createdAt
        updatedAt
        startDate
        endDate
        companyName
        phone
        faxNumber
        position
        dotNumber
        contactName
        email
        reasonForLeaving
        isDriverTerminated
        isDriverSubjectToFMCSRs
        isJobDesignatedAsSafetySensitiveFunctionUnderDOT
        shouldContactEmployer
        equipmentTypes
        carrierContactCount
        suppressedContactTypes
        carrierRouting {
          preferredPlatform
          platformOnly
        }
        address {
          street
          city
          state
          country
          zipCode
        }
        verificationOfEmployment {
          voeId
          status
        }
      }
      consents {
        consentId
        title
        confirmed
        signed
        document {
          documentId
          fileName
          path
          fileType
        }
      }
      questionResponses {
        applicationQuestionResponseId
        createdAt
        valueShortText
        valueLongText
        valueBoolean
        selectedOptions {
          applicationQuestionOptionResponseId
          customQuestionOptionId
          option {
            customQuestionOptionId
            label
            order
          }
        }
        templateQuestion {
          jobListingTemplateQuestionId
          isRequired
          order
          visibility
          question {
            customQuestionId
            label
            placeholder
            helpText
            fieldType
            options {
              customQuestionOptionId
              label
              order
            }
          }
        }
      }
    }
  }
`

export const GET_APPLICATION = gql`
  query Application($id: String!) {
    application(id: $id) {
      applicationId
      status
      firstName
      middleName
      lastName
      email
      phone
      dob
      ssn
      issuingCountry
      yearsOfExperience
      availableForWork
      createdAt
      updatedAt
      company {
        companyId
        documentIntelligenceEnabled
      }
      drivingExperiences {
        drivingExperienceId
        equipmentClass
        equipmentType
        startDate
        endDate
        approxMilesDriven
      }
      trackingLink {
        trackingLinkId
        linkType
        linkName
        link
      }
      accidents {
        accidentId
        createdAt
        updatedAt
        accidentDate
        city
        state
        country
        description
        isPreventable
        isCommercialMotorVehicleInvolved
        involvedFatalities
        involvedInjuries
      }
      applicant {
        applicantId
        yearsOfExperience
        applicationDate
        hiringStage
        applicantStage
        jobListing {
          jobListingId
          title
          type
          minEmploymentHistoryYears
        }
      }
      license {
        licenseId
        licenseNumber
        licenseClass
        state
        country
        expirationDate
        medicalExamExpirationDate
        endorsements
        createdAt
        updatedAt
        isLicenseSuspended
        licenseSuspendedReason
      }
      twicCard {
        twicCardId
        createdAt
        updatedAt
        cardNumber
        expirationDate
      }
      equipment {
        equipmentId
        createdAt
        updatedAt
        type
        year
        make
        model
        color
        vin
        weight
        mileage
        fifthWheelHeightInches
      }
      addresses {
        addressId
        street
        city
        state
        country
        zipCode
        startDate
        endDate
      }
      previousLicenses {
        licenseId
        licenseNumber
        licenseClass
        state
        country
        expirationDate
        medicalExamExpirationDate
        endorsements
        createdAt
        updatedAt
        isLicenseSuspended
        licenseSuspendedReason
      }
      employmentExperiences {
        employmentExperienceId
        createdAt
        updatedAt
        startDate
        endDate
        companyName
        phone
        faxNumber
        position
        dotNumber
        contactName
        email
        reasonForLeaving
        isUnemployment
        unemploymentReason
        isDriverTerminated
        isDriverSubjectToFMCSRs
        isJobDesignatedAsSafetySensitiveFunctionUnderDOT
        shouldContactEmployer
        equipmentTypes
        address {
          street
          city
          state
          country
          zipCode
        }
        verificationOfEmployment {
          voeId
          status
        }
      }
      consents {
        consentId
        title
        confirmed
        signed
        consentTemplate {
          fileName
        }
      }
      questionResponses {
        applicationQuestionResponseId
        createdAt
        valueShortText
        valueLongText
        valueBoolean
        selectedOptions {
          applicationQuestionOptionResponseId
          customQuestionOptionId
          option {
            customQuestionOptionId
            label
            order
          }
        }
        templateQuestion {
          jobListingTemplateQuestionId
          isRequired
          order
          visibility
          question {
            customQuestionId
            label
            placeholder
            helpText
            fieldType
            options {
              customQuestionOptionId
              label
              order
            }
          }
        }
      }
      company {
        companyId
        companyName
      }
    }
  }
`

export const UPDATE_APPLICATION = gql`
  mutation updateApplication($id: String!, $input: UpdateApplicationInput!) {
    updateApplication(id: $id, input: $input) {
      applicationId
      status
      firstName
      middleName
      lastName
      email
      phone
      dob
      ssn
      issuingCountry
      yearsOfExperience
      availableForWork
      createdAt
      updatedAt
      license {
        licenseId
        licenseNumber
        licenseClass
        state
        country
        expirationDate
        medicalExamExpirationDate
        endorsements
        isLicenseSuspended
        licenseSuspendedReason
      }
      previousLicenses {
        licenseId
        licenseNumber
        licenseClass
        state
        country
        expirationDate
        medicalExamExpirationDate
        endorsements
        isLicenseSuspended
        licenseSuspendedReason
      }
      twicCard {
        twicCardId
        createdAt
        updatedAt
        cardNumber
        expirationDate
      }
      equipment {
        equipmentId
        createdAt
        updatedAt
        type
        year
        make
        model
        color
        vin
        weight
        mileage
        fifthWheelHeightInches
      }
      accidents {
        accidentId
        createdAt
        updatedAt
        accidentDate
        city
        state
        country
        description
        isPreventable
        isCommercialMotorVehicleInvolved
        involvedFatalities
        involvedInjuries
      }
      drivingExperiences {
        drivingExperienceId
        equipmentClass
        equipmentType
        startDate
        endDate
        approxMilesDriven
      }
      addresses {
        addressId
        street
        city
        state
        country
        zipCode
        startDate
        endDate
      }
      employmentExperiences {
        employmentExperienceId
        createdAt
        updatedAt
        startDate
        endDate
        companyName
        phone
        faxNumber
        position
        dotNumber
        email
        contactName
        reasonForLeaving
        isDriverTerminated
        isDriverSubjectToFMCSRs
        isJobDesignatedAsSafetySensitiveFunctionUnderDOT
        shouldContactEmployer
        isUnemployment
        unemploymentReason
        equipmentTypes
        address {
          addressId
          street
          city
          state
          country
          zipCode
        }
        verificationOfEmployment {
          voeId
          status
        }
      }
    }
  }
`

export const MARK_APPLICATION_AS_SUBMITTED = gql`
  mutation markApplicationAsSubmitted($id: String!) {
    markApplicationAsSubmitted(id: $id)
  }
`

export const COPY_APPLICATION = gql`
  mutation copyApplication($input: CopyApplicationInput!) {
    copyApplication(input: $input) {
      newApplicationId
      newApplicantId
    }
  }
`
